export { WDot as default } from './WDot';
